import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.string.pad-start";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from "axios";
import { dldpget, dldpset, get_4g_data_dg, get_device4g } from "@/api/chuku";
export default {
  name: "deviceinfo",
  data: function data() {
    return {
      filteredSuppliers: [],
      dataRefreshInterval: null,
      did: this.$route.query.did,
      formItem: {
        ip: "",
        port: null,
        select: null
      },
      dg_status: null,
      wl_status: null,
      suppliers: [{
        value: 1,
        label: this.$t("永泰")
      }, {
        value: 2,
        label: this.$t("盾创")
      }, {
        value: 3,
        label: this.$t("比特安")
      }, {
        value: 4,
        label: this.$t("贝塞尔")
      }, {
        value: 5,
        label: this.$t("易鑫诺")
      }, {
        value: 6,
        label: this.$t("博观")
      }, {
        value: 7,
        label: this.$t("菲尼基")
      }, {
        value: 8,
        label: this.$t("智寻")
      }, {
        value: 9,
        label: this.$t("大能国科")
      }, {
        value: 10,
        label: this.$t("博龙")
      }, {
        value: 11,
        label: this.$t("龙磊")
      }, {
        value: 12,
        label: this.$t("长江龙")
      }]
    };
  },
  //  computed: {
  //       filteredSuppliers() {
  //           const ids = this.parseSupplierIds('AAMAAQACAAM=');
  //           return this.suppliers.filter(supplier => ids.includes(supplier.value));
  //       }
  //   },
  methods: {
    arrayToHex: function arrayToHex(arr) {
      return arr.map(function (byte) {
        return byte.toString(16).padStart(2, "0");
      }).join(","); // 用空格隔开
    },
    base64ToUint8Array: function base64ToUint8Array(base64) {
      // 解码 Base64 字符串
      var binaryString = atob(base64); // 创建一个新的 Uint8Array

      var byteLength = binaryString.length;
      var uint8Array = new Uint8Array(byteLength); // 将每个字符的 ASCII 值存储到 Uint8Array 中

      for (var i = 0; i < byteLength; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }

      return uint8Array;
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      var optionsRef = [{
        did: this.did,
        sdid: ["NULL"],
        dp_id: 2317,
        dp_chan: 0
      }];
      this.requestDeviceeReportOnce(optionsRef).then(function (data) {
        try {
          var dpcmd = {
            dpcmd: {
              t: 0,
              did: _this2.did,
              timestamp: Date.now(),
              ans: false,
              dpv_count: 1,
              dps: data
            }
          };
          dldpset(dpcmd).then(function (res) {
            if (res.result == 0) {
              var _dpcmd = {
                did: _this2.did,
                dpid: [2317],
                chan_num: 0
              };
              dldpget(_dpcmd).then(function (res) {
                console.log("wodadadsa", res);
                var valRawData = res.body.body.items[0].dps[0].val_raw;

                if (typeof valRawData === "string") {
                  // 将数据转换为 Uint8Array
                  var dataStr = _this2.base64ToUint8Array(valRawData);

                  var text = _this2.arrayToHex(_toConsumableArray(dataStr)); // 创建 Blob 对象


                  var blob = new Blob([text], {
                    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  }); // 创建下载链接

                  var url = URL.createObjectURL(blob);
                  var a = document.createElement("a");
                  a.href = url;
                  a.download = "数据内容"; // 设置下载文件名
                  // 触发下载

                  document.body.appendChild(a);
                  a.click(); // 清理

                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                } else {
                  console.error("valRawData 不是有效的 Base64 字符串");
                }
              });
            }
          });
        } catch (error) {
          console.error("请求错误:", error);
        }
      });
    },
    validateIP: function validateIP(ip) {
      var ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      return ipRegex.test(ip);
    },
    restart: function restart(val) {
      // 用户点击确认后执行以下代码
      var id = this.did;
      this.$Modal.confirm({
        title: "提示",
        content: this.$t("你确定要执行此操作吗？"),
        loading: true,
        onOk: function onOk() {
          var _this = this;

          var dpcmd = {
            dpcmd: {
              t: 0,
              did: id,
              sdid: "",
              seq: 1,
              timestamp: parseInt(new Date().getTime() / 1000),
              ans: false,
              dpv_count: 1,
              dps: [{
                dp_id: 2316,
                dp_type: 1,
                dp_chan: 0,
                val_int64: val === "4g" ? 1 : val === "bms" ? 2 : val === "hf" ? 3 : 0
              }]
            }
          };
          dldpset(dpcmd).then(function (res) {
            if (res.result == 0) {
              _this.$Message.success("重启成功");

              _this.$Modal.remove();
            } else {
              _this.$Message.error("重启失败");
            }
          });
        }
      });
    },
    saveData: function saveData(val) {
      var _this3 = this;

      if (val == "saveDk") {
        var base64Config = this.encodeServerConfig(this.formItem.ip, this.formItem.port, false);
        var dpcmd = {
          dpcmd: {
            t: 0,
            did: this.did,
            sdid: "",
            seq: 1,
            timestamp: parseInt(new Date().getTime() / 1000),
            ans: false,
            dpv_count: 1,
            dps: [{
              dp_id: 2315,
              dp_type: 4,
              dp_chan: 0,
              val_raw: _toConsumableArray(base64Config)
            }]
          }
        };
        dldpset(dpcmd).then(function (res) {
          if (res.result == 0) {
            _this3.$Message.success(_this3.$t("保存成功"));
          } else {
            _this3.$Message.error("保存失败");
          }
        });
      } else {
        var _base64Config = this.encodeServerConfig(this.formItem.ip, this.formItem.port, false);

        var _dpcmd2 = {
          dpcmd: {
            t: 0,
            did: this.did,
            sdid: "",
            seq: 1,
            timestamp: parseInt(new Date().getTime() / 1000),
            ans: false,
            dpv_count: 1,
            dps: [{
              dp_id: 2312,
              dp_type: 1,
              dp_chan: 0,
              val_int64: this.formItem.select
            }]
          }
        };
        dldpset(_dpcmd2).then(function (res) {
          if (res.result == 0) {
            _this3.$Message.success(_this3.$t("保存成功"));
          } else {
            _this3.$Message.error("保存失败");
          }
        });
      }
    },
    buildDpidQuery: function buildDpidQuery(dpids) {
      var count = dpids.length; // 计算缓冲区大小：1字节（count） + 每个dpid 4字节

      var buffer = new ArrayBuffer(1 + count * 4);
      var view = new DataView(buffer); // 写入count

      view.setUint8(0, count); // 写入每个dpid

      for (var i = 0; i < count; i++) {
        // 每个dpid占用4个字节，偏移位置为 1 + i * 4
        view.setUint32(1 + i * 4, dpids[i], false); // false表示大端字节序
      }

      return buffer;
    },
    //端口转byte
    encodeServerConfig: function encodeServerConfig(domain, port) {
      var littleEndian = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      // 1. 将域名转换为UTF-8字节数组
      var encoder = new TextEncoder();
      var domainBytes = encoder.encode(domain);
      var domainLength = domainBytes.length; // 2. 创建总Uint8Array (4字节端口 + 2字节长度 + 域名字节)

      var totalBytes = 4 + 2 + domainLength;
      var uint8Array = new Uint8Array(totalBytes); // 3. 使用DataView写入数据（按照字段顺序）

      var dataView = new DataView(uint8Array.buffer); // 第一个字段：port (uint32, 4字节)

      dataView.setUint32(0, port, littleEndian); // 第二个字段：ip_addr_len (uint16, 2字节)

      dataView.setUint16(4, domainLength, littleEndian); // 第三个字段：ip_addr (uint8数组，从偏移量6开始)

      for (var i = 0; i < domainLength; i++) {
        uint8Array[6 + i] = domainBytes[i];
      }

      return uint8Array;
    },
    //byte转换端口
    parseServerConfig: function parseServerConfig(base64Str) {
      var littleEndian = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // 1. Base64解码
      var binaryStr = atob(base64Str);
      var bytes = new Uint8Array(binaryStr.length);

      for (var i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
      }

      var dataView = new DataView(bytes.buffer);
      var offset = 0; // 2. 解析port (uint32, 4字节)

      var port = dataView.getUint32(offset, littleEndian);
      offset += 4; // 3. 解析ip_addr_len (uint16, 2字节)

      var ipAddrLen = dataView.getUint16(offset, littleEndian);
      offset += 2; // 4. 解析ip_addr (长度为ipAddrLen的字符串)

      var ipAddr = "";

      for (var _i = 0; _i < ipAddrLen; _i++) {
        ipAddr += String.fromCharCode(bytes[offset + _i]);
      }

      return {
        port: port,
        ipAddrLen: ipAddrLen,
        ipAddr: ipAddr
      };
    },
    buildQueryBuffer: function buildQueryBuffer(options) {
      var sdid = options.sdid,
          dp_id = options.dp_id,
          dp_chan = options.dp_chan,
          _options$lz4SrcLength = options.lz4SrcLength,
          lz4SrcLength = _options$lz4SrcLength === void 0 ? 0 : _options$lz4SrcLength,
          _options$littleEndian = options.littleEndian,
          littleEndian = _options$littleEndian === void 0 ? false : _options$littleEndian;
      var dpChansArr = Array.isArray(dp_chan) ? _toConsumableArray(dp_chan) : [dp_chan];
      var dpIdsArr = Array.isArray(dp_id) ? _toConsumableArray(dp_id) : [dp_id];
      console.log("dps配置项=====>", JSON.stringify({
        sdid: sdid,
        chans: dpChansArr,
        dpids: dpIdsArr
      }));
      var encoder = new TextEncoder();
      var queryBytesList = []; // 为每个dp_id创建一个查询条件

      for (var i = 0; i < dpIdsArr.length; i++) {
        var queryObj = {
          sdid: sdid[0] || "",
          // 取第一个sdid
          chans: [dpChansArr[i] || dpChansArr[0] || 0],
          // 使用对应的dp_chan
          dpids: [dpIdsArr[i]]
        };
        queryBytesList.push(encoder.encode(JSON.stringify(queryObj)));
      }

      var totalLen = 2 + 1 + queryBytesList.reduce(function (sum, b) {
        return sum + 2 + b.length;
      }, 0);
      var buffer = new ArrayBuffer(totalLen);
      var dv = new DataView(buffer);
      var offset = 0;
      dv.setUint16(offset, lz4SrcLength, littleEndian);
      offset += 2;
      dv.setUint8(offset, queryBytesList.length);
      offset += 1;

      for (var _i2 = 0; _i2 < queryBytesList.length; _i2++) {
        var bytes = queryBytesList[_i2];
        dv.setUint16(offset, bytes.length, littleEndian);
        offset += 2;
        new Uint8Array(buffer, offset, bytes.length).set(bytes);
        offset += bytes.length;
      }

      return new Uint8Array(buffer);
    },
    requestDeviceeReportOnce: function () {
      var _requestDeviceeReportOnce = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(options) {
        var mergedOption, unit8Data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!Array.isArray(options) || options.length === 0)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                // 将多个查询条件合并成一个
                mergedOption = {
                  did: options[0].did,
                  sdid: options[0].sdid,
                  // 使用第一个的sdid
                  dp_id: options.map(function (item) {
                    return item.dp_id;
                  }),
                  // 收集所有的dp_id
                  dp_chan: options.map(function (item) {
                    return item.dp_chan;
                  }),
                  // 收集所有的dp_chan
                  lz4SrcLength: options[0].lz4SrcLength || 0,
                  littleEndian: options[0].littleEndian || false
                };
                unit8Data = this.buildQueryBuffer(mergedOption);
                return _context.abrupt("return", [{
                  dp_id: 3556,
                  dp_chan: 0,
                  dp_type: 4,
                  val_raw: _toConsumableArray(unit8Data)
                }]);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requestDeviceeReportOnce(_x) {
        return _requestDeviceeReportOnce.apply(this, arguments);
      }

      return requestDeviceeReportOnce;
    }(),
    parseSupplierIds: function parseSupplierIds(base64Str) {
      var binaryString = atob(base64Str);
      var bytes = new Uint8Array(binaryString.length);

      for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      var count = bytes[0] << 8 | bytes[1];
      var result = [];

      for (var _i3 = 0; _i3 < count; _i3++) {
        var offset = 2 + _i3 * 2;
        var id = bytes[offset] << 8 | bytes[offset + 1];
        result.push(id);
      }

      return result; // 返回剩下的 id 数组
    },
    //获取状态
    getState: function getState() {
      this.updateData();
    },
    updateData: function updateData() {
      var _this4 = this;

      this.did = this.$route.query.did;
      var optionsRef = [{
        did: this.did,
        sdid: ["NULL"],
        dp_id: 2311,
        dp_chan: 0
      }, {
        did: this.did,
        sdid: ["NULL"],
        dp_id: 2312,
        dp_chan: 0
      }, {
        did: this.did,
        sdid: ["NULL"],
        dp_id: 2315,
        dp_chan: 0
      }, {
        did: this.did,
        sdid: ["NULL"],
        dp_id: 2313,
        dp_chan: 0
      }, {
        did: this.did,
        sdid: ["NULL"],
        dp_id: 2314,
        dp_chan: 0
      }];
      this.requestDeviceeReportOnce(optionsRef).then(function (data) {
        try {
          var dpcmd = {
            dpcmd: {
              t: 0,
              did: _this4.did,
              timestamp: Date.now(),
              ans: false,
              dpv_count: 1,
              dps: data
            }
          };
          dldpset(dpcmd).then(function (res) {
            if (res.result == 0) {
              var _dpcmd3 = {
                did: _this4.did,
                dpid: [2311, 2312, 2315],
                chan_num: 0
              };
              dldpget(_dpcmd3).then(function (response) {
                //端口域名
                var result = response.body.body.items.find(function (item) {
                  return item.dps && item.dps[0].dp_id === 2315;
                });

                var ipData = _this4.parseServerConfig(result.dps[0].val_raw);

                _this4.formItem.ip = ipData.ipAddr;
                _this4.formItem.port = ipData.port; //选中厂家

                var resultList = response.body.body.items.find(function (item) {
                  return item.dps && item.dps[0].dp_id === 2312;
                });
                _this4.formItem.select = resultList.dps[0].val_int64; //对应厂家

                var resultCj = response.body.body.items.find(function (item) {
                  return item.dps && item.dps[0].dp_id === 2311;
                });

                var ids = _this4.parseSupplierIds(resultCj.dps[0].val_raw);

                _this4.filteredSuppliers = _this4.suppliers.filter(function (supplier) {
                  return ids.includes(supplier.value);
                });
              });
              get_device4g({
                did: _this4.did
              }).then(function (res) {
                var channel = res.body.chans[0];
                setTimeout(function () {
                  get_4g_data_dg({
                    did: _this4.did,
                    chan: channel,
                    web_time: 0
                  }).then(function (response) {
                    _this4.dg_status = response.body.dg_status;
                    _this4.wl_status = response.body.wl_status;
                  });
                }, 2000);
              });
            }
          });
        } catch (error) {
          console.error("请求错误:", error);
        }
      }).catch(function (error) {
        console.error("请求失败:", error);
      });
    }
  },
  mounted: function mounted() {
    this.updateData();
    console.log("5155", this.$route, this.$route.query.did);
  },
  beforeDestroy: function beforeDestroy() {// 在组件销毁前清除定时器
    // console.log("销毁了");
    // clearInterval(this.dataRefreshInterval);
  }
};